import { Button, Card } from '../components/ui';
import { PoliticaConteudo } from './PoliticaConteudo';
import styles from './screens.module.css';

/**
 * Página pública de Política de Privacidade (#74) — acessível sem login em
 * `/privacidade`. Não depende de sessão nem de tenant.
 */
export function PrivacidadePublica() {
  return (
    <div
      className={styles.centerScreen}
      style={{ alignItems: 'flex-start', padding: 'var(--space-4)' }}
    >
      <div style={{ width: 'min(760px, 100%)', margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 style={{ fontSize: 'var(--step-3)' }}>Política de Privacidade</h1>
          <Button variant="ghost" size="sm" onClick={() => window.location.assign('/')}>
            ← Voltar
          </Button>
        </div>
        <Card>
          <PoliticaConteudo />
        </Card>
      </div>
    </div>
  );
}
